import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProjectsService } from '@/app/services/projects/projects.service';

@Component({
  selector: 'app-select-project-design',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './select-project-design.component.html',
  styleUrl: './select-project-design.component.css',
})
export class SelectProjectDesignComponent implements OnInit {
  @Output() navigateTab: EventEmitter<string> = new EventEmitter<string>();

  currentTab = 'Drawing';

  drawingDocuments = [];
  specificationsDocuments = [];
  calculationsDocuments = [];
  surverysReportsDocuments = [];
  designReviewsDocuments = [];
  permitsDocuments = [];
  designSignOffDocuments = [];
  rfiDocuments = [];

  // When user clicks on a tab, we update the value of currentSelectedDesign to that variable
  currentSelectedDesign = [];

  selectActiveTabAllFiles: boolean = false;

  // TODO: this will hold all selected files from all tabs
  selectedFiles = {
    drawing: [],
    specifications: [],
    calculations: [],
    surverys_reports_studies: [],
    design_review_reports: [],
    permits_and_applications: [],
    design_signoff: [],
    rfi: [],
    addendums: [],
  };

  documentTypes: string[] = [
    'drawing',
    'specifications',
    'calculations',
    'surverys_reports_studies',
    'design_review_reports',
    'permits_and_applications',
    'design_signoff',
    'rfi',
  ];

  constructor(
    private projectService: ProjectsService,
    @Inject(MAT_DIALOG_DATA) public readonly dialogData: any,
    private rfpQueryDesignUploadDialogRef: MatDialogRef<SelectProjectDesignComponent>
  ) {}

  ngOnInit(): void {
    if (this.dialogData.selectedFiles) {
      this.selectedFiles = this.dialogData.selectedFiles;
    }
    this.getProjectDocuments('drawing');
  }

  toggleSelectAll(): void {
    // this.drawing.forEach(drawing => drawing.selected = this.selectActiveTabAllFiles);
  }

  toggleCurrentTabFileSelection(fileRow: any): void {
    switch (this.currentTab) {
      case 'Drawing':
        this.selectedFiles.drawing.push(fileRow);
        break;
      case 'Specifications':
        this.selectedFiles.specifications.push(fileRow);
        break;
      case 'Calculations':
        this.selectedFiles.calculations.push(fileRow);
        break;
      case 'Surveys, Reports and Studies':
        this.selectedFiles.surverys_reports_studies.push(fileRow);
        break;
      case 'Design Review Reports':
        this.selectedFiles.design_review_reports.push(fileRow);
        break;
      case 'Permits and Applications':
        this.selectedFiles.permits_and_applications.push(fileRow);
        break;
      case 'Design Sign Off':
        this.selectedFiles.design_signoff.push(fileRow);
        break;
      case 'RFI':
        this.selectedFiles.rfi.push(fileRow);
        break;
      default:
        break;
    }
  }

  processSelectedDesigns(success: boolean = false) {
    this.rfpQueryDesignUploadDialogRef.close({
      success: success,
      selectedFiles: this.selectedFiles,
    });
  }

  close(success: boolean = false) {
    this.rfpQueryDesignUploadDialogRef.close({ success: success });
  }

  setTab(currentTab: string, type: string) {
    this.getProjectDocuments(type);
    this.currentTab = currentTab;
    this.getCurrentTabDesigns();
    this.formatStringType(type);
  }

  getCurrentTabDesigns() {
    switch (this.currentTab) {
      case 'Drawing':
        return this.drawingDocuments;
      case 'Specifications':
        return this.specificationsDocuments;
      case 'Calculations':
        return this.calculationsDocuments;
      case 'Surveys, Reports and Studies':
        return this.surverysReportsDocuments;
      case 'Design Review Reports':
        return this.designReviewsDocuments;
      case 'Permits and Applications':
        return this.permitsDocuments;
      case 'Design Sign Off':
        return this.designSignOffDocuments;
      case 'RFI':
        return this.rfiDocuments;
      default:
        return [];
    }
  }

  formatStringType(type: string): string {
    return type
      .split('_') // Split by underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(' '); // Join with spaces
  }

  populateVariablesWithDocuments(data: any, type: string) {
    switch (type) {
      case 'drawing':
        this.drawingDocuments = data;
        break;

      case 'specifications':
        this.specificationsDocuments = data;
        break;

      case 'calculations':
        this.calculationsDocuments = data;
        break;

      case 'surverys_reports_studies':
        this.surverysReportsDocuments = data;
        break;

      case 'design_review_reports':
        this.designReviewsDocuments = data;
        break;

      case 'permits_and_applications':
        this.permitsDocuments = data;
        break;

      case 'design_signoff':
        this.designSignOffDocuments = data;
        break;

      case 'rfi':
        this.rfiDocuments = data;
        break;

      default:
        break;
    }
  }

  /**
   * HTTP REQUESTS START
   */
  getProjectDocuments(type: string = 'drawing') {
    return this.projectService
      .getProjectDesignDocuments(this.dialogData.projectId, type)
      .subscribe({
        next: (response: any) => {
          if (response.meta.success) {
            let fetchedDocuments = response?.data;

            // Retrieve previously selected documents for this tab
            const selectedTabFiles = this.selectedFiles[type] || [];

            // Map selected state to fetched documents
            fetchedDocuments = fetchedDocuments.map((doc: any) => ({
              ...doc,
              selected: selectedTabFiles.some(
                (selectedDoc) => selectedDoc.id === doc.id
              ),
            }));

            // Update the corresponding variable
            this.populateVariablesWithDocuments(fetchedDocuments, type);
          }
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        },
      });
  }

  /**
   * HTTP REQUESTS END
   */
}
